export const isFunction = (fn: unknown) => typeof fn === 'function';
